/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { renderErrorMsg } from "../../assets/component/renderErrorMsg.js";
import "./OrgLoginPassword.css";
import { PLATFORM } from "../../config";
import errorMsg from "../../assets/json/errMsg.json";
import { Link } from "react-router-dom";
import { renderOrgLanguageSelector } from "../../assets/component/renderOrgLanguageSelector.js";

class OrgLoginPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      orgInfo: {
        username: "",
        password: "",
      },
      language: this.props.language,
      errorMsg: {
        username: {
          msg: "",
        },
        password: {
          msg: "",
        },
      },
    };
    this.setOrgInfoData = this.setOrgInfoData.bind(this);
    this.handleUsername = this.handleUsername.bind(this);
    this.handlepw = this.handlepw.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.btnForgotPassword = this.btnForgotPassword.bind(this);
  }

  componentDidMount() {
    try {
      if (
        this.props.location.state === null ||
        this.props.location.state === undefined
      ) {
        this.props.history.push({
          pathname: "/OrgLogin",
        });
        return; // Don't continue if redirecting
      }

      this.setState({
        orgInfo: {
          username: this.props.location.state.username,
          password: "",
        },
      });
    } catch (e) {
      this.props.history.push({
        pathname: "/OrgLogin",
      });
    }
  }

  setOrgInfoData(s, name) {
    let data = this.state.orgInfo;
    data[name] = s;
    this.setState({
      orgInfo: data,
    });
  }

  handleUsername(e) {
    var errStateMsg = this.state.errorMsg;
    errStateMsg.username.msg = "";
    const value = e.target.value;
    this.setState({
      errorMsg: errStateMsg,
    }, () => {
      // Callback ensures error message is cleared before updating username (React 18 fix)
      this.setOrgInfoData(value, "username");
    });
  }

  handlepw(e) {
    this.setOrgInfoData(e.target.value, "password");
  }

  btnForgotPassword() {
    this.props.history.push({
      pathname: "/OrgForgotPassword",
      state: {
        username: this.state.orgInfo.username,
      },
    });
  }

  handleSubmit() {
    if (this.state.loading) return false;

    this.setState({
      loading: true,
    });
    this.props.orgLogin(this.state.orgInfo).then((res) => {
      this.setState({
        loading: false,
      });
      var errStateMsg = this.state.errorMsg;
      switch (res.status) {
        case 404:
          break;
        case 403:
          errStateMsg.username.msg = !res.body.message
            ? ""
            : errorMsg[this.state.language].loginErr.loginEmailErr;
          this.setState({
            errorMsg: errStateMsg,
          });
          break;
        case 422:
          if (res.body.errors)
            errStateMsg.username.msg = !res.body.errors.username.msg
              ? ""
              : errorMsg[this.state.language].loginErr.loginEmailErr;
          else errStateMsg.username.msg = "";
          if (res.body.message)
            errStateMsg.password.msg = !res.body.message
              ? ""
              : errorMsg[this.state.language].pwErr.passwdErr;
          else errStateMsg.password.msg = "";
          this.setState({
            errorMsg: errStateMsg,
          });
          break;
        case 204:
          this.props.history.push({
            pathname: "/AccountOverview",
          });
          break;
        default:
          break;
      }
    });
  }

  render() {
    if (
      this.state.loading ||
      this.props.location.state === null ||
      this.props.location.state === undefined
    ) {
      return (
        <div className="OrgLoginPassword-view">
          <div className="OrgLoginPassword-loadingprompt">
            <this.props.RenderFullPageLoading />
          </div>
        </div>
      );
    }

    const languageObj = this.props.languageObj;

    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        this.handleSubmit();
      }
    };

    return (
      <div className="OrgLoginPassword-view">
        <div className="OrgLoginPassword-prompt">
          <Link to={"/OrgLogin"}>
            <div className="OrgLoginPassword-backContainer">
              <div className="OrgLoginPassword-backBtn" />
            </div>
          </Link>

          <div className="OrgLoginPassword-languageBar">
            <div className="OrgLoginPassword-globe" />
            <div className="OrgLoginPassword-languageSelector">
              {renderOrgLanguageSelector()}
            </div>
          </div>

          <div className="OrgLoginPassword-loginContainer">
            <div className="OrgLoginPassword-CheckPlusLogoContainer">
              {/* Use conditional class based on platform */}
              <div
                className={
                  PLATFORM === "plug"
                    ? "OrgLoginPassword-PlugLogo"
                    : "OrgLoginPassword-CheckPlusLogo"
                }
              />
            </div>
            <div className="OrgLoginPassword-loginText">
              {languageObj.loginText}
            </div>

            <div className="OrgLoginPassword-text">{languageObj.text}</div>

            <div>
              <div className="OrgLoginPassword-inputFieldContainerLong">
                <input
                  type="text"
                  className="OrgLoginPassword-inputFieldLong"
                  placeholder={languageObj.inputFieldLong}
                  value={this.state.orgInfo.username}
                  onChange={this.handleUsername}
                  onKeyDown={handleKeyDown}
                  disabled
                />
              </div>
              {renderErrorMsg(this.state.errorMsg.username.msg)}

              <div className="OrgLoginPassword-inputFieldContainer">
                <div className="OrgLoginPassword-inputContainerLeft">
                  <input
                    type="password"
                    className="OrgLoginPassword-inputField"
                    value={this.state.orgInfo.password}
                    onChange={this.handlepw}
                    placeholder={languageObj.inputField}
                    onKeyDown={handleKeyDown}
                    data-testid="orgloginpassword-password-input"
                  />
                </div>
                <div className="OrgLoginPassword-inputContainerRight">
                  <div
                    onClick={this.handleSubmit}
                    className="OrgLoginPassword-nextBtn"
                    data-testid="orgloginpassword-submit-btn"
                  >
                    <div className="OrgLoginPassword-nextIcn" />
                  </div>
                </div>
              </div>
              {renderErrorMsg(this.state.errorMsg.password.msg)}
              <div
                className="OrgLoginPassword-forgotPassword"
                onClick={this.btnForgotPassword}
              >
                {languageObj.forgotPassword}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

OrgLoginPassword.propTypes = {
  orgLogin: PropTypes.func,
  language: PropTypes.string,
  languageObj: PropTypes.object,
};

export default OrgLoginPassword;
